'use client'

import { InlineStaticVariant } from '@repo/web-ui/components/static-variants-renderer/inline/inline-static-variant'
import { DOES_NOT_HAVE_ALL_ACCESS } from '@repo/web-ui/components/static-variants-renderer/utils/conditions'
import {
  CURRENCIES,
  withCurrency,
} from '@repo/web-ui/components/static-variants-banner/banners.static-variants'

import { CtaButton } from './cta-button'

export function Cta({ labelTemplate }: { labelTemplate: string }) {
  return (
    <>
      {CURRENCIES.map(currency => {
        const label = labelTemplate.replace(/{currency}/gi, currency.symbol)
        return (
          <InlineStaticVariant
            key={currency.code}
            conditions={[DOES_NOT_HAVE_ALL_ACCESS, withCurrency(currency.code)]}
            getVariant={({ conditionsMet }) => (conditionsMet ? <CtaButton label={label} /> : null)}
          />
        )
      })}
    </>
  )
}
